import { format as formatRut, validate as validateRut } from './rut.js';

/* ============================================================
   Boleta / Factura – MyCOCOS
   - Busca sus campos DENTRO del propio <boleta-factura> (no con IDs globales).
   - Se inicializa en connectedCallback: funciona en la carga inicial y cada vez
     que Focal vuelve a dibujar el mini-carrito.
   - La validación del botón "checkout" se registra UNA sola vez (delegada).
   - Recuerda lo que el cliente escribió si el mini-carrito se re-renderiza.
   ============================================================ */

const r = (regionName, regionCode, comunas) => ({
  regionName,
  regionCode,
  regionProvinces: comunas.map(displayName => ({ displayName }))
});

const regionesComunas = [
  r('Metropolitana de Santiago', 'RM', ['Alhué', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí', 'Curacaví', 'El Bosque', 'El Monte', 'Estación Central', 'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida', 'La Granja', 'Lampa', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'María Pinto', 'Melipilla', 'Ñuñoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Peñaflor', 'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín', 'San José de Maipo', 'San Miguel', 'San Pedro', 'San Ramón', 'Santiago', 'Talagante', 'Tiltil', 'Vitacura']),
  r('Tarapacá', 'TA', ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte']),
  r('Antofagasta', 'AN', ['Antofagasta', 'Calama', 'María Elena', 'Mejillones', 'Ollagüe', 'San Pedro de Atacama', 'Sierra Gorda', 'Taltal', 'Tocopilla']),
  r('Atacama', 'AT', ['Alto del Carmen', 'Caldera', 'Chañaral', 'Copiapó', 'Diego de Almagro', 'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar']),
  r('Coquimbo', 'CO', ['Andacollo', 'Canela', 'Combarbalá', 'Coquimbo', 'Illapel', 'La Higuera', 'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paiguano', 'Punitaqui', 'Río Hurtado', 'Salamanca', 'Vicuña']),
  r('Valparaíso', 'VS', ['Algarrobo', 'Cabildo', 'Calera', 'Calle Larga', 'Cartagena', 'Casablanca', 'Catemu', 'Concón', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua', 'Juan Fernández', 'La Cruz', 'La Ligua', 'Limache', 'Llaillay', 'Los Andes', 'Nogales', 'Olmué', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncaví', 'Putaendo', 'Quillota', 'Quilpué', 'Quintero', 'Rinconada', 'San Antonio', 'San Esteban', 'San Felipe', 'Santa María', 'Santo Domingo', 'Valparaíso', 'Villa Alemana', 'Viña del Mar', 'Zapallar']),
  r('Libertador General Bernardo OHiggins', 'LI', ['Chépica', 'Chimbarongo', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machalí', 'Malloa', 'Marchihue', 'Mostazal', 'Nancagua', 'Navidad', 'Olivar', 'Palmilla', 'Paredones', 'Peralillo', 'Peumo', 'Pichidegua', 'Pichilemu', 'Placilla', 'Pumanque', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa', 'San Fernando', 'Santa Cruz', 'San Vicente']),
  r('Maule', 'ML', ['Cauquenes', 'Chanco', 'Colbún', 'Constitución', 'Curepto', 'Curicó', 'Empedrado', 'Hualañé', 'Licantén', 'Linares', 'Longaví', 'Maule', 'Molina', 'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro', 'Río Claro', 'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier', 'San Rafael', 'Talca', 'Teno', 'Vichuquén', 'Villa Alegre', 'Yerbas Buenas']),
  r('Biobío', 'BI', ['Alto Biobío', 'Antuco', 'Arauco', 'Cabrero', 'Cañete', 'Chiguayante', 'Concepción', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpén', 'Hualqui', 'Laja', 'Lebu', 'Los Álamos', 'Los Ángeles', 'Lota', 'Mulchén', 'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco', 'San Pedro de la Paz', 'San Rosendo', 'Santa Bárbara', 'Santa Juana', 'Talcahuano', 'Tirúa', 'Tomé', 'Tucapel', 'Yumbel']),
  r('La Araucanía', 'AR', ['Angol', 'Carahue', 'Cholchol', 'Collipulli', 'Cunco', 'Curacautín', 'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco', 'Nueva Imperial', 'Padre las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Purén', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén', 'Traiguén', 'Victoria', 'Vilcún', 'Villarrica']),
  r('Los Lagos', 'LL', ['Ancud', 'Calbuco', 'Castro', 'Chaitén', 'Chonchi', 'Cochamó', 'Curaco de Vélez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufú', 'Hualaihué', 'Llanquihue', 'Los Muermos', 'Maullín', 'Osorno', 'Palena', 'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldón', 'Purranque', 'Puyehue', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Río Negro', 'San Juan de la Costa', 'San Pablo']),
  r('Aysén del General Carlos Ibáñez del Campo', 'AI', ['Aysén', 'Chile Chico', 'Cisnes', 'Cochrane', 'Coihaique', 'Guaitecas', 'Lago Verde', 'O’Higgins', 'Río Ibáñez', 'Tortel']),
  r('Magallanes y de la Antártica Chilena', 'MA', ['Antártica', 'Cabo de Hornos', 'Laguna Blanca', 'Natales', 'Porvenir', 'Primavera', 'Punta Arenas', 'Río Verde', 'San Gregorio', 'Timaukel', 'Torres del Paine']),
  r('Los Ríos', 'LR', ['Corral', 'Futrono', 'Lago Ranco', 'Lanco', 'La Unión', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia']),
  r('Arica y Parinacota', 'AP', ['Arica', 'Camarones', 'General Lagos', 'Putre']),
  r('Ñuble', 'NB', ['Bulnes', 'Chillán', 'Chillán Viejo', 'Cobquecura', 'Coelemu', 'Coihueco', 'El Carmen', 'Ninhue', 'Ñiquén', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillón', 'Quirihue', 'Ránquil', 'San Carlos', 'San Fabián', 'San Ignacio', 'San Nicolás', 'Treguaco', 'Yungay'])
];

function validateEmail(email) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
}

const escapeHtml = s => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

/* Lo que el cliente va escribiendo (sobrevive al re-render del mini-carrito) */
const state = {};
const FIELDS = ['rutInput', 'giroInput', 'razonSocialInput', 'addressInput', 'regionInput', 'comunaInput', 'emailInput'];

class BoletaFactura extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;

    const $ = id => this.querySelector('#' + id);
    const els = {
      tabs: $('tabs-container'),
      sections: $('sections-container'),
      rut: $('rutInput'),
      giro: $('giroInput'),
      razon: $('razonSocialInput'),
      address: $('addressInput'),
      region: $('regionInput'),
      comuna: $('comunaInput'),
      email: $('emailInput')
    };

    /* Si el contenido todavía no está (o falta algún campo), no hacemos nada y no rompemos nada */
    if (Object.values(els).some(el => !el)) return;

    this._ready = true;
    this.els = els;

    const markInvalid = (el, invalid) => el.parentElement.classList.toggle('invalid', invalid);
    const save = () => FIELDS.forEach(id => { const el = $(id); if (el) state[id] = el.value; });

    const fillComunas = (code, selected) => {
      const region = regionesComunas.find(rg => rg.regionCode === code);
      els.comuna.innerHTML = region
        ? region.regionProvinces.map(p => `<option value="${escapeHtml(p.displayName)}">${escapeHtml(p.displayName)}</option>`).join('')
        : '';
      if (selected) els.comuna.value = selected;
    };

    const toggleSections = () => {
      const checked = els.tabs.querySelector('input:checked');
      const isFactura = !!checked && checked.value === 'Factura';
      els.sections.classList.toggle('active', isFactura);
      return isFactura;
    };

    this.textValidation = el => {
      el.value = el.value.toUpperCase();
      const ok = el.value.trim().length > 0;
      markInvalid(el, !ok);
      return ok;
    };

    /* --- Listeners --- */
    els.tabs.addEventListener('change', () => {
      const isFactura = toggleSections();
      state.tipo = isFactura ? 'Factura' : 'Boleta';
      if (isFactura) els.rut.focus();
    });

    els.rut.addEventListener('keydown', e => {
      if (e.key.length === 1 && !/[0-9kK]/.test(e.key)) e.preventDefault();
    });
    els.rut.addEventListener('keyup', () => {
      els.rut.value = formatRut(els.rut.value);
      markInvalid(els.rut, !(els.rut.value.length === 0 || validateRut(els.rut.value)));
      save();
    });

    [els.giro, els.razon, els.address].forEach(el => {
      el.addEventListener('keyup', () => { this.textValidation(el); save(); });
    });

    els.email.addEventListener('keyup', () => {
      markInvalid(els.email, !(els.email.value.length === 0 || validateEmail(els.email.value)));
      save();
    });

    els.region.addEventListener('change', e => {
      if (e.target.value === '0') {
        markInvalid(els.region, true);
        els.comuna.innerHTML = '';
      } else {
        markInvalid(els.region, false);
        fillComunas(e.target.value);
      }
      save();
    });

    els.comuna.addEventListener('change', save);

    /* --- Estado inicial (restaura lo escrito si el carrito se re-renderizó) --- */
    ['rutInput', 'giroInput', 'razonSocialInput', 'addressInput', 'emailInput'].forEach(id => {
      if (state[id]) $(id).value = state[id];
    });
    els.region.value = state.regionInput && state.regionInput !== '0' ? state.regionInput : '0';
    if (els.region.value !== '0') fillComunas(els.region.value, state.comunaInput);
    if (state.tipo) {
      const radio = els.tabs.querySelector(`input[value="${state.tipo}"]`);
      if (radio) radio.checked = true;
    }
    toggleSections();
  }

  disconnectedCallback() {
    this._ready = false;
  }

  /* Devuelve true si se puede seguir al checkout */
  validate() {
    if (!this._ready) return true;
    const { tabs, rut, giro, razon, address, region, email } = this.els;
    const checked = tabs.querySelector('input:checked');
    if (!checked || checked.value !== 'Factura') return true;

    let valid = true;
    const fail = el => { if (valid) el.focus(); valid = false; };

    if (!validateRut(rut.value)) { rut.parentElement.classList.add('invalid'); fail(rut); }
    if (!this.textValidation(giro)) fail(giro);
    if (!this.textValidation(razon)) fail(razon);
    if (!this.textValidation(address)) fail(address);
    if (region.value === '0') { region.parentElement.classList.add('invalid'); fail(region); }
    if (!validateEmail(email.value)) { email.parentElement.classList.add('invalid'); fail(email); }

    return valid;
  }
}

/* Validación del botón "Ir a pagar": un solo listener para siempre,
   aunque el mini-carrito se vuelva a dibujar mil veces. */
if (!window.__boletaFacturaCheckoutGuard) {
  window.__boletaFacturaCheckoutGuard = true;
  document.addEventListener('click', e => {
    const button = e.target.closest && e.target.closest('[name="checkout"]');
    if (!button) return;
    const visible = [...document.querySelectorAll('boleta-factura')].find(el => el.isConnected && el.offsetParent !== null) ||
                    document.querySelector('boleta-factura');
    if (visible && typeof visible.validate === 'function' && !visible.validate()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }, true);
}

if (!customElements.get('boleta-factura')) {
  customElements.define('boleta-factura', BoletaFactura);
}